import store from "src/store/index"
import InfoSystem from "./info/main.js"  // 消息系统对象
import {instance} from 'src/config/axiosConfig.js'  //axios实例对象
// import { socket_server } from "src/config/address.js";  //websocket服务地址
const socket_server = window.address.socket_server;  //websocket服务地址

//******数据的列表  数据的查询****
function createArg(arg){  //生成确实的参数
    let flag;
    let func;
    if(arg.length == 1){
        let str = typeof arg[0];
        if(str.toLocaleLowerCase() == "boolean"){
            flag = arg[0];
        }
        if(str.toLocaleLowerCase() == "function"){
            func = arg[0];
        }
    }else if(arg.length == 2){
        let str1 = typeof arg[0];
        let str2 = typeof arg[1];
        if(str1.toLocaleLowerCase() == "boolean" && str2.toLocaleLowerCase() == "function"){
            flag = arg[0];
            func = arg[1];
        }else{
            throw `getTaskTpl 参数错误`;
        }
    }
    return [flag,func];
}

// 常用的功能  
export default {
    // 登出
    logout(){
        // 会做一些处理
        store.state.userInfo = {};
        InfoSystem.close();
    },

    // 用户信息  和 用户BU信息
    getUserInfo(...arg){  //获取登录用户的信息
        let flag;
        let func;
        [flag,func] = createArg(arg);
    
        if(flag || store.state.userInfo && store.state.userInfo.id == undefined){
            instance.get("api/user").then(res => {
                var info = res.res_data || {};
                if(res.status == 800){   //session过期
                    func && func({});
                }else{
                    store.state.userInfo = info;
                    func && func({...info});
                    console.log(`用户信息：拉取`);
                }
            });
            return;
        }
    
        console.log(`用户信息：缓存`);
        func && func({...store.state.userInfo});
    },
    getUserBu(...arg){ //获取登录用户BU信息
        let flag;
        let func;
        [flag,func] = createArg(arg);
    
        if(flag || store.state.buInfo.id == undefined){
            instance.get("api/user/bu").then(res => {
                var info = res.res_data;
                store.state.buInfo = info;
                console.log(`BU信息:拉取`);
                func && func({...info});
            });
            return;
        }
    
        console.log(`BU信息：缓存`);
        func && func({...store.state.buInfo});
    },

    getBuList(...arg){   //获取可选的BU list
        let flag;
        let func;
        [flag,func] = createArg(arg);
    
        if(flag || store.state.bu_list.length == 0){
            instance.get("api/admin/bu/list").then(res => {
                if(res.status == 200){
                    let list = res.res_data;
                    store.state.bu_list = list;
                    console.log(`BU可选列表:拉取`);
                    func && func([...list]);
                }
            });
            return;
        }
        console.log(`BU可选列表：缓存`);
        func && func([...store.state.bu_list]);
    },
    // 获取bu成员信息
    getBuMembers(...arg){
        let flag;
        let func;
        [flag,func] = createArg(arg);
    
        if(flag || store.state.bu_users.length == undefined){
            instance.get("api/manager/bu_user").then(res => {
                if(res.status == 200){
                    let list = res.res_data.sort((a,b)=>{
                        return a.bu_identity_type - b.bu_identity_type
                    });
                    store.state.bu_users = list;
                    console.log(`BU成员:拉取`);
                    func && func([...list]);
                }
            });
            return;
        }
        console.log(`BU成员：缓存`);
        func && func([...store.state.bu_users]);
    },

    // 任务类型
    getTaskTpl(...arg){    //获取任务类型 列表
        let flag;
        let func;
        [flag,func] = createArg(arg);
        if(flag || store.state.taskTpl.length == 0){
            instance.get('api/clerk/task_tpl').then(res => {
                var list = res.res_data;
                store.state.taskTpl = list;
                console.log(`任务类型：拉取`);
                func && func([...list]);
            });
            return;
        }
    
        console.log(`任务类型：缓存`);
        func && func([...store.state.taskTpl]);
    },
    queryTaskTpl(id){   //查询 任务类型
        if(id == undefined){
            return {};
            // throw `queryTaskTpl 缺少参数`;
        }
    
        // if(store.state.taskTpl.length == 0){
        //     // throw `store taskTpl 为空数组`;
        // }
    
        return store.getters.taskTplObj[id] || {};
    },

    // 快币类型
    getCurrencyList(...arg){    //快币类型 列表
        let flag;
        let func;
        [flag,func] = createArg(arg);
    
        if(flag || store.state.currencyList.length == 0){
            instance.get('api/clerk/currency').then(res => {
                var list = res.res_data;
                store.state.currencyList = list;
                console.log(`快币类型：拉取`);
                func && func([...list]);
            });
            return;
        }
    
        console.log(`快币类型：缓存`);
        func && func([...store.state.currencyList]);
    },
    queryCurrency(id){   //查询 快币类型
        if(id == undefined){
            // throw `queryCurrency 缺少参数`;
            return {};
        }
        // if(store.state.currencyList.length == 0){
        //     // throw `store currencyList 为空数组`;
        //     getCurrencyList(true);
        // }
    
        return store.getters.currencyObj[id] || {};
    },
    getCurr(key){
        console.log(111)
        this.getCurrencyList();
        if(key == 'task' || undefined){
            return store.getters.task_curr;
        }else if(key == 'ticket'){
            return store.getters.ticket_curr;
        }
    },

    // 全部个人罚单
    getPersonalTicket(...arg){
        let flag;
        let func;
        [flag,func] = createArg(arg);
    
        if(flag || store.state.personalTicket.length == 0){
            instance.get('api/clerk/cfg_ticket/personal').then(res => {
                var list = res.res_data;
                store.state.personalTicket = list;
                console.log(`个人罚单类型：拉取`);
                func && func([...list]);
            });
            return;
        }
    
        console.log(`个人罚单类型：缓存`);
        func && func([...store.state.personalTicket]);
    },

    // 公司岗位列表
    getPost(...arg){
        let flag;
        let func;
        [flag,func] = createArg(arg);
    
        if(flag || store.state.allPost.length == 0){

            instance.get("api/user/position/all").then(res=>{  //拿 增岗岗位list
                var list = res.res_data;
                store.state.allPost = list;
                console.log(`岗位列表：拉取`);
                func && func([...list]);
            });
            return;
        }

        console.log(`岗位列表：缓存`);
        func && func([...store.state.allPost]);
    },

    // 公司奖金周期
    getBonusCycle(...arg){ 
        let flag;
        let func;
        [flag,func] = createArg(arg);
    
        if(flag || store.state.allBonusCycle.length == 0){

            instance.get(`api/clerk/cycle_detail/year_num`).then(res=>{ 
                var list = res.res_data;
                store.state.allBonusCycle = list;
                console.log(`奖金周期列表：拉取`);
                func && func([...list]);
            });
            return;
        }

        console.log(`奖金周期列表：缓存`);
        func && func([...store.state.allBonusCycle]);
    },
    queryBonusCycle(id){
        if(id == undefined){
            throw `queryBonusCycle 缺少参数`;
            return {};
        }
        // if(store.state.currencyList.length == 0){
        //     // throw `store currencyList 为空数组`;
        //     getCurrencyList(true);
        // }
        let res = {};
        store.state.allBonusCycle.some(cycle=>{
            return cycle.id == id && (res = {...cycle});
        });
        return res;
    },

    // 全屏遮罩
    loading(flag){
        store.state.screenFullFlag = flag;
    },

    //*** 消息系统相关
    // websocket
    getLink(user_info){  //链接socket  建立信息系统
        instance.post(`http://${socket_server}/socket`,user_info)
        .then(res=>{
            InfoSystem.build(res,user_info);
        })
    },

    // 标记消息已读
    hasRead(id,func,errDeal){
        let url = `api/websocket/msg/user/update`;
        instance.post(url,{
            info_id:id
        })
        .then(res=>{
            if(res.status == 200){
                func && func();
                InfoSystem.remove(id);
            }
        })
        .catch(err=>{
            errDeal && errDeal(err);
        });
    }
}

// *******生成特定数据*************

export const getBonusCycleOptions = function(year){  //生成奖金周期选项
    if(!year){
        return [];
    }

    return store.state.allBonusCycle.filter(item=>{
        return item.cycle_year == year;
    }).sort((a,b)=>a.cycle_number - b.cycle_number);
}

export const lastYearDate = (function(){  //获取一年前的时间点
    let yearSecond = 365 * 24 * 3600 * 1000;
    return function(arg){
        if(arg == "second"){
            return yearSecond;
        }else{
            let curDate = typeof arg == "object"?arg.getTime():(new Date()).getTime();
			let pastResult = curDate - yearSecond; 
			let pastDate = new Date(pastResult);
			return pastDate;
        }
    }
})();


// *********其他**************
export const scrollBottom = function(dom,second){  //滚动到底部
    let timer;
    let result = dom.scrollTop;
    let end = dom.scrollHeight;
    let step = Math.round( (end - result)*10/second );

    timer = setInterval(function(){
        if(result >= end){
            clearInterval(timer);
            return;
        }

        result+=step;
        dom.scrollTop =  result;
    },10);
}

export const scrollTo = function(dom,second,px){  //滚动到特定位置
    let timer;
    let result = dom.scrollTop;
    let end = dom.scrollHeight;
    let tar = px==undefined?end:parseFloat(px);  //目标位置
    
    console.log(tar);

    let step = Math.round( (tar - result)*10/second );

    timer = setInterval(function(){
        if(result*step >= tar*step){
            clearInterval(timer);
            return;
        }

        result+=step;
        dom.scrollTop = result;
        console.log(result);
    },10);
}

export const insertAfter = function(newEl, el){  //插入节点
    let parentEl = el.parentNode;
    if(parentEl.lastChild == el){
        parentEl.appendChild(newEl);
    }else{
        parentEl.insertBefore(newEl,el.nextElementSibling);
    }            
}


// ****组件公用方法****

export const changeType = function(keyStr){ //审核页面 更改状态
    this[keyStr].date_start = "";
    this[keyStr].date_end = "";
    this[keyStr+"Search"]();
}

// 提示功能
export const errorTip = function(str = "发送失败") {  //错误小提示
    this.$message({
        message: str,
        type: 'error',
    });
}

export const successTip = function(str = '提交成功') {   //成功小提示
    this.$message({
        // showClose:true,
        message: str,
        type: 'success',
        // duration:0,
    });
}




// WEBPACK FOOTER //
// ./src/control/common.js